import React, { useEffect, useState } from 'react'
import dataLayer from '../../../helpers/functions/dataLayer'
import { t } from '../../../i18n'
import SpinnerWithText from '../../spinnerWithText/SpinnerWithText'
import StandardModal from '../standardModal/StandardModal'
import styles from './avisoTareasMantenimiento.module.scss'

interface Props {
  setOpenModal: (open: boolean) => void
  openModal: boolean
  setMaintenanceShown: () => void
}

const AvisoTareasMantenimiento = ({
  setOpenModal,
  openModal,
  setMaintenanceShown,
}: Props) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (openModal) {
      dataLayer.push({
        event: 'callback',
        action: success ? 'conversion' : 'open',
      })
    }
  }, [openModal, success])

  const closeModal = () => {
    setOpenModal(false)
    setLoading(false)
    setSuccess(false)
    setMaintenanceShown()
  }

  return (
    <StandardModal
      closeModal={closeModal}
      showModal={openModal}
      title={t('aviso_mantenimiento.title')}
      modalClass={styles.modal_small}>
      {loading && <SpinnerWithText text="Cargando..." />}

      <div className={styles.modal_wrapper_step1}>
        {t('aviso_mantenimiento.descripcion')}
      </div>
    </StandardModal>
  )
}

export default AvisoTareasMantenimiento
